<template>
  <el-popover placement="bottom"
              width="330"
              @show="init"
              trigger="click">
    <!--重置-->
    <el-button @click="resetChecked"
               type="text"
               size="mini">{{ $t('reset') }}</el-button>
    <!-- @check-change="handleCheckChange"  overflow-y: auto;-->
    <el-tree style="max-height:400px;"
             ref="classTrees"
             :data="treeData"
             show-checkbox
             accordion
             node-key="catalogId"
             @node-click="handleNodeClick"
             @check="handleCheck"
             :props="defaultProps"
             :default-expanded-keys="[1]"
             :filter-node-method="filterNode"><!-- @check-change="handleCheckChange"-->
        <span class="span-ellipsis" slot-scope="{ node, data }">
		  <span :title="node.label">{{ node.label }}</span>
                <!-- <div class="cell el-tooltip" :title="node.label" >{{node.label}} -->
                <!-- </div> -->
	   </span>
    </el-tree>
    <el-input slot="reference"
              :disabled="disabled"
              placeholder="请选择"
              clearable
              readonly
              v-model.trim="className"></el-input>
  </el-popover>
</template>
<script>
import { treeDataWithDisableTranslate } from '@/utils'
export default {
  name: 'catalogtree',
  props: {
    // 默认是单选
    isSelect: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // defaultProps
    defaultProps: {
      type: Object,
      default: null,
      required: true
    },
    // url forExample: /rm/vehicleclass/list
    url: {
      type: String,
      default: '',
      required: true
    },

    // 默认显示的数组
    showArray: {
      type: Array,
      required: false
    },
    // 回填显示的文本
    showValue: {
      type: String,
      default: '',
      required: false
    },
    // 是否活动
    filterText: {
      type: String,
      default: '',
      required: false
    },
    // 状态字段
    status: {
      type: String,
      default: '',
      required: false
    }
  },
  data () {
    return {
      arr: this.showArray,
      checkedValTemlist: [],
      treeData: [],
      dataListLoading: false,
      className: ''
    }
  },
  watch: {
    // 监听分类名称
    // 筛选
    filterText (val) {
      // this.$message('1' + val)
      this.$refs.classTrees.filter(val)
    }
  },
  components: {
  },
  mounted () {
    this.queryVehinfoClass()
  },
  methods: {
    getShowValue (val) {
        this.className = val
    },
    init () {
      this.$refs.classTrees.setCheckedKeys(this.showArray)
    },
    handleNodeClick(data) {
      // console.log(data)
    },
    // 查询车型分类树
    queryVehinfoClass () {
      this.dataListLoading = true
      // this.$message('11111' + this.isSelect)
      this.$request.get(
        this.url,
        { 'disable': this.isSelect }
      ).then((res, total, code, data) => {
        this.dataListLoading = false
        // data.result
        let resultList = treeDataWithDisableTranslate(data.data, 'catalogId', 'parentCatalogId')
        console.log(resultList)
        this.treeData = resultList
        let arr = JSON.parse(JSON.stringify(resultList))[0].children
        let newArr = arr.filter(it => it.catalogId === 9)[0].children
        this.$emit("getParent_checked", newArr)
        this.$nextTick(() => {
          this.$refs.classTrees.filter(this.filterText)
        })
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    // 重置车型分类树
    resetChecked: function resetChecked () {
      this.className = ''
      this.$refs.classTrees.setCheckedKeys([])
    },
    // 筛选
    filterNode (value, data) {
      // this.$emit('cateloglist', '1111')
      // this.$message('########' + this.status + '888' + value + '**' + data)
      if (!value) return true
      return data[this.status].indexOf(value) !== -1
    },
    handleCheck (a,b) {
      if (b.checkedKeys.length > 0) {
        this.$refs.classTrees.setCheckedKeys([a.catalogId])
        this.className = a.catalogName
      }
      this.$emit('catelogObj', JSON.parse(JSON.stringify(a)))
    },
    closeEmit () {
      console.log('closeEmit')
    },
    // 勾选分类树 树时调用
   /* handleCheckChange (data, checked, indeterminate) {
      console.log(data)
      var rss = this.$refs.classTrees.getCheckedNodes()
      console.log(rss)
      console.log(this.$refs.classTrees.getCheckedNodes(true, false))
      let cnName = this.defaultProps.label
      let checkedShowValTem = ''
      if (rss.length !== 0) {
        if (this.isSelect) {
          if (checked === true) {
            this.$refs.classTrees.setCheckedNodes([data])
          }
        }
        let checkedValTem = []
        checkedShowValTem = ''
        this.$refs.classTrees.getCheckedNodes(true, false).forEach(function (item) {
          checkedValTem.push(item)
          checkedShowValTem = checkedShowValTem + item[cnName]
        })
        // this.$emit('cateloglist', checkedValTem)
        this.className = checkedShowValTem // .substr(0, checkedShowValTem.length - 1)
      } else {
        // this.$message('1111111111')
        checkedShowValTem = ''
        var rs = this.$refs.classTrees.getCheckedNodes()
        rs.forEach(row => {
          // this.checkedValTems.push({ catalogNameCn: row.catalogNameCn })
          checkedShowValTem = checkedShowValTem + row.catalogNameCn
        })
        // this.$message('2222221' + checkedShowValTem + this.checkedValTems)
        // this.$emit('cateloglist', checkedShowValTem)
        // this.$emit('appenddata', [{ names: nams, data: this.infiledList }])

        this.className = checkedShowValTem.substr(0, checkedShowValTem.length - 1)
        // this.$message('222' + this.className)
      }
      // this.$emit('inputs', '111')
      var rssa = this.$refs.classTrees.getCheckedNodes()
      rssa.forEach(row => {
        // this.$message('111111111111111111111111111111111' + row.catalogId)
        this.checkedValTemlist.push({ catalogId: row.catalogId, catalogNameCn: row.catalogNameCn })
      })
      this.$emit('cateloglist', [{ data: this.checkedValTemlist }])
      this.checkedValTemlist = []
      // this.$message('111111111111111111111111111111111')
      // this.$message('111111111111111111111111111111111')
    }*/
  }
}
</script>
<style>
</style>
